import React from "react";
import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center space-x-2 text-sm p-3"
    >
      {items.map((item, index) => (
        <div key={index} className="flex items-center text-primary-main">
          {index > 0 && <span className="mx-2 ">/</span>}
          {index === items.length - 1 ? (
            <span className="font-medium ">{item.label}</span>
          ) : (
            <Link
              to={item.path}
              className="hover:text-brand-light hover:underline"
            >
              {item.label}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
